/* ---------- Compliance Tracker - Consultant Fill In  ------------------

This is the first compoent of the consultant fill in where the consultant must choose the she file that they 
would like to fill in, This component will display new submissions and exisiting submissions. 
  
*/

// ------------------ React Components ------------------------
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// -------------------- API -----------------------------
import API_BASE_URL from "../../utils/api/apiConfig.js";


// --------------------- CSS File --------------------
import '../../../assets/css/Checklists.css';

// --------------------- icons --------------------

import { LiaSpinnerSolid } from "react-icons/lia";



import { FaRegFolderOpen } from "react-icons/fa";

// --------------------- Assests -------------------
import blueKbcLogo from '../../../assets/images/branding/blue-kbc-logo.png';

import ToasterConsultantTemplateFill from './ToasterConsultantTemplateFill.js';



// --------------------- View SHE Pack component -------------------
const ConsultantTempateFillInComponent = () => {

  const [selectedSubmissionId, setSelectedSubmissionId] = useState(null);

  // Retrieve user data from session storage
  const user = JSON.parse(sessionStorage.getItem('user'));

  const navigate = useNavigate();

  // --------------- State Managements ------------------------

  const [newSubmissionErrors, setNewSubmissionErrors] = useState({});

  /*----------------------- Filters ------------------------------- */
  
// Add these state variables with your existing state declarations
const [filterCompany, setFilterCompany] = useState('');
const [filterSite, setFilterSite] = useState('');
const [filterSheFile, setFilterSheFile] = useState('');

// Add this computed state for unique filter options
const [uniqueCompanies, setUniqueCompanies] = useState([]);
const [uniqueSites, setUniqueSites] = useState([]);
const [uniqueSheFiles, setUniqueSheFiles] = useState([]);

  // ----------------- SUbmissions ---------------
  // Add new state for existing submissions
const [newSubmissions, setNewSubmissions] = useState([]);
const [existingSubmissions, setExistingSubmissions] = useState([]);

  // New state for companies and departments
  const [sheFileCompanies, setSheFileCompanies] = useState({});
  const [selectedCompanies, setSelectedCompanies] = useState({});
  const [selectedCompanyName, setSelectedCompanyName] = useState({});

  
  const [departmentsPerCompany, setDepartmentsPerCompany] = useState({});
  const [selectedDepartments, setSelectedDepartments] = useState({});
  const [selectedDepartmentName, setSelectedDepartmentName] = useState({});

  

  // State Management - Global 
  const [submissionStatus, setSubmissionStatus] = useState('Not Started');


  // State Management - selected she pack
  const [selectedSheFileId, setSelectedSheFileId] = useState(null);
  const [selectedSheFileName, setSelectedSheFileName] = useState('');

  const [selectedSheFileUserScore, setSelectedSheFileUserScore] = useState(null);
  const [currentUserScore, setCurrentUserScore] = useState(selectedSheFileUserScore);
  const [selectedSheFileScore, setSelectedSheFileScore] = useState(null);

  const [templates, setTemplates] = useState([]);
  const [templateResponses, setTemplateResponses] = useState([]);
  

  // state management - slected document 
  // Add these state variables near your other state declarations
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [selectedTemplateName, setSelectedTemplateName] = useState('');
  const [selectedTemplateScore, setSelectedTemplateScore] = useState('');
  const [selectedTemplateUserPercentage, setSelectedTemplateUserPercentage] = useState('');


  //
  const [assignedSheFiles, setAssignedSheFiles] = useState([]);

  
  //
  const [showTemplateToaster, setShowTemplateToaster] = useState(false);

 
  const [isLoading, setIsLoading] = useState(true);
  
  

  // ------------------- Functions ---------------------------

  useEffect(() => {

    //
  const fetchSubmissions = async () => {
    setIsLoading(true);
    
    try {
      // Fetch new submissions
      const newResponse = await axios.get(`${API_BASE_URL}/api/compliance-tracker/consultant/template-fill-in/new-submissions/${user.user_id}`);
      setNewSubmissions(newResponse.data);

      // Fetch existing submissions
      const existingResponse = await axios.get(`${API_BASE_URL}/api/compliance-tracker/consultant/template-fill-in/existing-submissions/${user.user_id}`);
      setExistingSubmissions(existingResponse.data);

      // Fetch companies and departments for new submissions
      for (const shefile of newResponse.data) {
        
        const companiesResponse = await axios.get(
          `${API_BASE_URL}/api/compliance-tracker/consultant-fill-in/consultant-assignments/company/${shefile.shefile_id}/${user.user_id}`
        );
        
        setSheFileCompanies(prev => ({
          ...prev,
          [shefile.shefile_id]: companiesResponse.data
        }));

        const departmentsMap = {};
        companiesResponse.data.forEach(companyData => {
          departmentsMap[companyData.company] = companyData.departments;
        });
        
        setDepartmentsPerCompany(prev => ({
          ...prev,
          [shefile.shefile_id]: departmentsMap
        }));
      }

    } catch (error) {
      console.error('Error fetching submissions:', error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchSubmissions();
}, [user.user_id]);

// Add this useEffect to populate unique filter options when newSubmissions changes
useEffect(() => {
  if (newSubmissions && newSubmissions.length > 0) {
    // Extract unique companies
    const companies = [...new Set(newSubmissions.map(item => item.company_name))].sort();
    setUniqueCompanies(companies);
    
    // Extract unique sites
    const sites = [...new Set(newSubmissions.map(item => item.department_name))].sort();
    setUniqueSites(sites);
    
    // Extract unique SHE files
    const sheFiles = [...new Set(newSubmissions.map(item => item.shefile_name))].sort();
    setUniqueSheFiles(sheFiles);
  }
}, [newSubmissions]);

// Add this filtered data computation
const filteredNewSubmissions = newSubmissions.filter(sheFile => {
   // If no filters are selected, show nothing
  if (!filterCompany && !filterSite && !filterSheFile) {
    return false;
  }

  const matchesCompany = !filterCompany || sheFile.company_name === filterCompany;
  const matchesSite = !filterSite || sheFile.department_name === filterSite;
  const matchesSheFile = !filterSheFile || sheFile.shefile_name === filterSheFile;
  
  return matchesCompany && matchesSite && matchesSheFile;
});

//
// Add filter reset function
const resetFilters = () => {
  setFilterCompany('');
  setFilterSite('');
  setFilterSheFile('');
};



  
  
  // Fucntions - Global
  const handleNavigateBack = () => {
    navigate(-1);
  };

  // User Score Calcutaltions 
  const handleScoreUpdate = (newScore) => {
    setCurrentUserScore(newScore);
  };

  // Update the handleClick function to include company and department

  // Add this function in ConsultantTempateFillInComponent
  // Updated refreshAssignedSheFiles function
  const refreshAssignedSheFiles = async () => {
    setIsLoading(true);
      
    try {
      // If we have a selected SHE file with company and department, refresh it specifically
      if (selectedSheFileId && selectedCompanies[selectedSheFileId] && selectedDepartments[selectedSheFileId]) {
        const companyId = selectedCompanies[selectedSheFileId];
        const departmentId = selectedDepartments[selectedSheFileId];
        
        const response = await axios.get(
          `${API_BASE_URL}/api/compliance-tracker/consultant/template-fill-in/assigned-she-files/${user.user_id}/${companyId}/${departmentId}`
        );
        
        const processedSheFiles = response.data.map(shefile => ({
          ...shefile,
          total_submissions: shefile.total_submissions 
            ? parseInt(shefile.total_submissions, 10) 
            : 0
        }));
        
        // Update the assignedSheFiles state by replacing the updated file
        setAssignedSheFiles(prev => 
          prev.map(file => {
            const updatedFile = processedSheFiles.find(updated => updated.shefile_id === file.shefile_id);
            return updatedFile || file;
          })
        );
        
        // Update the selected SHE file score
        const updatedSheFile = processedSheFiles.find(file => file.shefile_id === selectedSheFileId);
        if (updatedSheFile) {
          setSelectedSheFileUserScore(updatedSheFile.user_score);
          setSelectedSheFileScore(updatedSheFile.shefile_score);
        }
      } 
      
    } catch (error) {
      console.error('Error refreshing data:', error);
    } finally {
      setIsLoading(false);
    }
};

  //
  const refreshTemplates = async () => {
  // Only proceed if we have the required data
  if (!selectedSheFileId || !selectedCompanies[selectedSheFileId] || !selectedDepartments[selectedSheFileId]) {
    console.error('Missing required data for template refresh');
    return;
  }

  setIsLoading(true);

  try {
    const companyId = selectedCompanies[selectedSheFileId];
    const departmentId = selectedDepartments[selectedSheFileId];

    console.log('Refreshing templates for:', {
      sheFileId: selectedSheFileId,
      companyId,
      departmentId
    });

    // Fetch updated SHE file data with specific company and department
    const updatedSheFileResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant/template-fill-in/assigned-she-files/${user.user_id}/${companyId}/${departmentId}`
    );

    // Update the user score with the specific company/department data
    const specificSheFile = updatedSheFileResponse.data.find(file => file.shefile_id === selectedSheFileId);
    if (specificSheFile) {
      setSelectedSheFileUserScore(specificSheFile.user_score);
    }

    // Fetch templates only
    const templatesResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant-fill-in/view-assigned-templates/${selectedSheFileId}/${companyId}/${departmentId}`
    );

    // Fetch template responses separately
    const templateResponsesResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant-fill-in/view-template-responses/${user.user_id}/${selectedSheFileId}/${companyId}/${departmentId}`
    );

    console.log('Templates Refresh API Response:', templatesResponse.data);
    console.log('Template Responses Refresh API Response:', templateResponsesResponse.data);

    if (templatesResponse.status === 200 && templateResponsesResponse.status === 200) {
      if (Array.isArray(templatesResponse.data)) {
        const templates = templatesResponse.data;
        const templateResponses = templateResponsesResponse.data;
        
        // Merge templates with their responses
        const mergedTemplates = templates.map(template => {
          // Find corresponding response for this template
          const response = templateResponses.find(resp => 
            resp.template_id === template.template_id &&
            resp.shefile_id === template.shefile_id
          );
          
          // Merge template with response data
          return {
            ...template,

            // Template
            template_id: template.template_id,
            template_name: template.template_name,
            template_reference: template.template_reference,
            template_score: template.template_score,
            template_frequency: template.template_frequency,
            submission_type: template.submission_type,
            
            // Template Responses
            template_response_document_id: response?.template_response_document_id,
          compliance_template_submission_id: response?.compliance_template_submission_id,
          template_submission_status: response?.template_submission_status,
          template_user_score: response?.template_user_score,
          template_user_percentage: response?.template_user_percentage,
          period: response?.period,
          file_period: response?.file_period,
          qa_status: response?.qa_status,
          qa_comment: response?.qa_comment, 

          //
          date_submitted: response?.date_submitted
          };
        });
        
        setTemplates(mergedTemplates);
        setTemplateResponses(templateResponses);
      }
    }

  } catch (error) {
    console.error('Error refreshing templates:', error);
  } finally {
    setIsLoading(false);
  }
};

//
const handleClickExistingSubmission = async (sheFileId, sheFileName, sheFileUserScore, sheFileScore, submissionId) => {
  setIsLoading(true);
  setSelectedSheFileId(sheFileId);
  setSelectedSheFileName(sheFileName);
  setSelectedSheFileUserScore(sheFileUserScore);
  setSelectedSheFileScore(sheFileScore);
  setSelectedSubmissionId(submissionId); // Add this line

  // Get the full sheFile object from existingSubmissions using BOTH sheFileId AND submissionId
  const sheFile = existingSubmissions.find(file => 
    file.shefile_id === sheFileId && file.submission_id === submissionId
  );

  if (!sheFile) {
    console.error('SHE File not found for submission:', submissionId);
    setIsLoading(false);
    return;
  }

  try {
    const companyId = sheFile.company;
    const departmentId = sheFile.department;

    // Use submission_id as part of the state key to differentiate between submissions
    const stateKey = `${sheFileId}_${submissionId}`;

    // Save to selectedCompanies and selectedDepartments states with unique keys
    setSelectedCompanies(prev => ({ ...prev, [stateKey]: companyId }));
    setSelectedCompanyName(prev => ({ ...prev, [stateKey]: sheFile.company_name }));
    setSelectedDepartments(prev => ({ ...prev, [stateKey]: departmentId }));
    setSelectedDepartmentName(prev => ({ ...prev, [stateKey]: sheFile.department_name }));

    // Also set the current selection for the toaster (using original sheFileId for backward compatibility)
    setSelectedCompanies(prev => ({ ...prev, [sheFileId]: companyId }));
    setSelectedCompanyName(prev => ({ ...prev, [sheFileId]: sheFile.company_name }));
    setSelectedDepartments(prev => ({ ...prev, [sheFileId]: departmentId }));
    setSelectedDepartmentName(prev => ({ ...prev, [sheFileId]: sheFile.department_name }));

    const updatedSheFileResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant/template-fill-in/assigned-she-files/${user.user_id}/${companyId}/${departmentId}`
    );

    const specificSheFile = updatedSheFileResponse.data.find(file => file.shefile_id === sheFileId);
    if (specificSheFile) {
      setSelectedSheFileUserScore(specificSheFile.user_score);
    }

    // Fetch templates with submission_id in the API call
    const templatesResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant-fill-in/view-assigned-templates/${sheFileId}/${companyId}/${departmentId}`
    );

    // Fetch template responses with submission_id parameter
    const templateResponsesResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant-fill-in/view-template-responses/${user.user_id}/${sheFileId}/${companyId}/${departmentId}?submission_id=${submissionId}`
    );

    if (templatesResponse.status === 200 && templateResponsesResponse.status === 200) {
      const mergedTemplates = templatesResponse.data.map(template => {
        const response = templateResponsesResponse.data.find(resp =>
          resp.template_id === template.template_id && 
          resp.shefile_id === template.shefile_id &&
          resp.submission_id === submissionId // Add this condition
        );

        return {
          ...template,
          template_id: template.template_id,
          template_name: template.template_name,
          template_reference: template.template_reference,
          template_score: template.template_score,
          template_frequency: template.template_frequency,
          submission_type: template.submission_type,

          // responses 
          template_response_document_id: response?.template_response_document_id,
          compliance_template_submission_id: response?.compliance_template_submission_id,
          template_submission_status: response?.template_submission_status,
          template_user_score: response?.template_user_score,
          template_user_percentage: response?.template_user_percentage,
          period: response?.period,
          file_period: response?.file_period,
          qa_status: response?.qa_status,
          qa_comment: response?.qa_comment, 
          date_submitted : response?.date_submitted,  
          submission_id: submissionId // Add this to track which submission this belongs to
        };
      });

      setTemplates(mergedTemplates);
      setTemplateResponses(templateResponsesResponse.data);
      setShowTemplateToaster(true);
    }
  } catch (error) {
    console.error('Error fetching existing submission data:', error);
  } finally {
    setIsLoading(false);
  }
};


    // Update the handleClick function to include company and department
    // Update the handleClick function to include company and department
const handleClickNewSubmissions = async (sheFileId, sheFileName, sheFileUserScore, sheFileScore, companyId, departmentId, companyName, departmentName) => {
  setIsLoading(true);
  setSelectedSheFileId(sheFileId);
  setSelectedSheFileName(sheFileName);
  setSelectedSheFileUserScore(sheFileUserScore);
  setSelectedSheFileScore(sheFileScore);

  // Set the company and department information in state
  setSelectedCompanies(prev => ({ ...prev, [sheFileId]: companyId }));
  setSelectedCompanyName(prev => ({ ...prev, [sheFileId]: companyName }));
  setSelectedDepartments(prev => ({ ...prev, [sheFileId]: departmentId }));
  setSelectedDepartmentName(prev => ({ ...prev, [sheFileId]: departmentName }));

  // Clear any existing errors for this sheFile
  setNewSubmissionErrors(prev => ({
    ...prev,
    [sheFileId]: ''
  }));

  try {
    // Fetch updated SHE file data with specific company and department
    const updatedSheFileResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant/template-fill-in/assigned-she-files/${user.user_id}/${companyId}/${departmentId}`
    );

    // Update the user score with the specific company/department data
    const specificSheFile = updatedSheFileResponse.data.find(file => file.shefile_id === sheFileId);
    if (specificSheFile) {
      setSelectedSheFileUserScore(specificSheFile.user_score);
    }

    // Fetch templates only (without responses)
    const templatesResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant-fill-in/view-assigned-templates/${sheFileId}/${companyId}/${departmentId}`
    );

    // Fetch template responses separately
    const templateResponsesResponse = await axios.get(
      `${API_BASE_URL}/api/compliance-tracker/consultant-fill-in/view-template-responses/${user.user_id}/${sheFileId}/${companyId}/${departmentId}`
    );

    if (templatesResponse.status === 200 && templateResponsesResponse.status === 200) {

      if (Array.isArray(templatesResponse.data)) {

        const templates = templatesResponse.data;
        const templateResponses = templateResponsesResponse.data;
        
        // Merge templates with their responses
        const mergedTemplates = templates.map(template => {
          // Find corresponding response for this template
          const response = templateResponses.find(resp => 
            resp.template_id === template.template_id &&
            resp.shefile_id === template.shefile_id
          );
          
          // Merge template with response data
          return {
            ...template,
            // Template
            template_id: template.template_id,
            template_name: template.template_name,
            template_reference: template.template_reference,
            template_score: template.template_score,
            template_frequency: template.template_frequency,
            submission_type: template.submission_type,
            
            // Template Responses
            compliance_template_submission_id: response?.compliance_template_submission_id,
            template_submission_status: response?.template_submission_status,
            template_user_score: response?.template_user_score,
            user_template_percentage: response?.user_template_percentage,
            period: response?.period,
            period_expiry_date: response?.period_expiry_date,
            qa_status: response?.qa_status,
            qa_comment: response?.qa_comment
          };
        });
        
        setTemplates(mergedTemplates);
        setTemplateResponses(templateResponses);
        setShowTemplateToaster(true);
      }
    }
  } catch (error) {
    console.error('Error fetching SHE File data:', error);
    setNewSubmissionErrors(prev => ({
      ...prev,
      [sheFileId]: 'Error! Oops, seems like there\'s something wrong.'
    }));
  } finally {
    setIsLoading(false);
  }
};

  // Function - Submissions 
  
  return (
    <div >
      <div className="create-checklist-component-container">

        <div className="create-company-text-container">

          <div>
      
            <h2> Compliance Tracker - <span className="secondary-color-paragraph">Consultant Fill In</span></h2>
                
              <p>The following SHE files have been assigned to you and have not been started.</p>
              
          </div>

          <div>
              <img src={blueKbcLogo} alt="white-kbc-logo" className="side-menu-logo" />
          </div>
          
        </div>

        <div className="navigate-back-button-main-container">
          <div className="navigate-back-button-container">
            <button className="navigate-back-button" onClick={handleNavigateBack}>Back</button>
          </div>
        </div>

        {/* New Submissions Table */}
        <div className="view-checklist-table-container">
          {isLoading ? (
            <div className="loading-spinner-container">
              <LiaSpinnerSolid className="lia-spin-solid-icon" />
            </div>
          ) : (
            <div className="view-checklist-table-table-container">

              <div>
                  <h3>Section A - <span className="secondary-color-paragraph">New Submission</span></h3>
                  <p>Below are the submissions that have been assigned to you but not have been started. </p>
              </div>

              <div>


                <div>
                  <h3>Filter</h3>
                  <p>Use this filter to refine your search criteria.</p>
                </div>

                <div className='consultant-template-fill-in-filters-main-container'>
                  <div className='consultant-template-fill-in-filters-container'>
                    
                    {/* Company Filter */}
                    <div>
                      <div>
                        <p>By Company Name : </p>
                      </div>
                      <div>
                        <select 
                          value={filterCompany} 
                          onChange={(e) => setFilterCompany(e.target.value)}
                          disabled={filterSite || filterSheFile}
                        >
                          <option value="">-- Select Company --</option>
                          {uniqueCompanies.map((company, index) => (
                            <option key={index} value={company}>
                              {company}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    

                    {/* SHE File Filter */}
                    <div>
                      <div>
                        <p>SHE File : </p>
                      </div>
                      <div>
                        <select 
                          value={filterSheFile} 
                          onChange={(e) => setFilterSheFile(e.target.value)}
                          disabled={filterCompany || filterSite}
                        >
                          <option value="">-- Select SHE Files --</option>
                          {uniqueSheFiles.map((sheFile, index) => (
                            <option key={index} value={sheFile}>
                              {sheFile}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Reset Button */}
                    <div>
                      <button 
                        onClick={resetFilters}
                        className="cancel-button"
                      >
                        Reset Filters
                      </button>
                    </div>
                    
                  </div>
                </div>
              </div>

              <table className="view-checklist-table">

                <colgroup>

                  {/* Remove whitespace between col elements */}
                  <col style={{width: "100px"}}/>{/* Select SHE Pack */}
                  <col style={{width: "300px"}}/>{/* Company */} 
                  <col style={{width: "300px"}}/>{/* Department */} 
                  <col style={{width: "300px"}}/>{/* Select SHE Pack */}
                  <col style={{width: "200px"}}/>{/* SHE Pack Name */}
                  <col style={{width: "200px"}}/>{/* SHE Pack Score */}        
                  <col style={{width: "200px"}}/>{/* SHE Pack Score */} 
                  <col style={{width: "200px"}}/>{/* Department */} 
                       
                </colgroup>

                <thead>
                  <tr>
                    <th className="table-header"> # </th>
                    <th className="table-header">Company</th>
                    <th className="table-header">Site</th>
                    <th className="table-header">SHE File Name</th>
                    <th className="table-header">Submission Id</th>
                    <th className="table-header">Submission Status</th>
                    <th className="table-header">QA Status</th>
                    <th className="table-header">Select SHE File</th>
                    
                  </tr>
                </thead>

                <tbody className="view-table-body">

                  {filteredNewSubmissions && filteredNewSubmissions.length === 0 ? ( 
                    <tr>
                      <td colSpan="7">
                        <i>There are no new SHE Files assigned to you. For more information please contact support. </i>

                      </td>
                    </tr>
                  ) : (
                    filteredNewSubmissions.map((sheFile, index) => (

                      <tr key={index}>

                        {/* column - SHE Pack name */}
                        <td>{index + 1}</td>

                        {/* column - Compnay Name  */}
                        <td>{sheFile.company_name}</td>

                        {/* column - Compnay Name  */}
                        <td>{sheFile.department_name}</td>

                        {/* column - SHE Pack name */}
                        <td>
                          {sheFile.shefile_name}
                          {newSubmissionErrors[sheFile.shefile_id] && (
                          <div className="error-text-main-container" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
                            {newSubmissionErrors[sheFile.shefile_id]} 
                          </div>
                        )}

                        </td>

                        {/* column - SHE Pack name */}
                        <td>{sheFile.submission_id || '-'}</td>

                        

                        {/* column - SHE Pack submission status */}
                        <td>{sheFile.submission_status || 'No Submissions'}</td>

                        {/* column - SHE Pack submission status */}
                        <td>{sheFile.qa_status || "-"}</td>

                      

                        

                        {/* column - view SHE pack */}
                        <td>
                          {sheFile.submission_status === "Completed" ? (
                            // When submission status is "Completed", show disabled icon with "no entry" cursor
                            <div className="disabled-icon-container" title="Submission is already completed">
                              <FaRegFolderOpen className='view-checklist-submition-icon disabled' style={{ cursor: 'not-allowed' }} />
                            </div>
                          ) : (
                            // Updated onClick - pass company and department IDs directly from sheFile
                            <div onClick={() => handleClickNewSubmissions(
                              sheFile.shefile_id, 
                              sheFile.shefile_name, 
                              sheFile.user_score, 
                              sheFile.shefile_score,
                              sheFile.company,        // Pass company ID directly
                              sheFile.department_id,      // Pass department ID directly
                              sheFile.company_name,        // Pass company ID directly
                              sheFile.department_name      // Pass department ID directly
                            )}>
                              <FaRegFolderOpen className='view-checklist-submition-icon' />
                            </div>
                          )}
                        </td>

                        

                        
                        
                      
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {/* Existing Submission */}
        <div className="view-checklist-table-container">
          {isLoading ? (
            <div className="loading-spinner-container">
              <LiaSpinnerSolid className="lia-spin-solid-icon" />
            </div>
          ) : (
            <div className="view-checklist-table-table-container">

              <div>
                  <h3>Section B - <span className="secondary-color-paragraph">Exisitng Submissions</span></h3>
                  <p>The following SHE files have been assigned to you and are currently in progress.</p>
              </div>

              <table className="view-checklist-table">

                <colgroup>
                  <col style={{ width: "30px" }} />   {/* # */}
                  <col style={{ width: "200px" }} />  {/* Company */}
                  <col style={{ width: "200px" }} />  {/* Site */}
                  <col style={{ width: "300px" }} />  {/* SHE File Name */}
                  <col style={{ width: "200px" }} />  {/* Submission Id */}
                  <col style={{ width: "200px" }} />  {/* Submission Status */}
                  <col style={{ width: "200px" }} />  {/* QA Status */}
                  <col style={{ width: "200px" }} />  {/* Select SHE File */}
                </colgroup>


                <thead>
                  <tr>
                    <th className="table-header">#</th>
                    <th className="table-header">Company</th>
                    <th className="table-header">Site</th>
                    <th className="table-header">SHE File Name</th>
                    <th className="table-header">Submission Id</th>
                    <th className="table-header">Submission Status</th>
                    <th className="table-header">QA Status</th>
                    <th className="table-header">Select SHE File</th>
                    
                    
                  </tr>
                </thead>

                <tbody className="view-table-body">

                  {existingSubmissions && existingSubmissions.length === 0 ? ( 
                    <tr>
                      <td colSpan="6">
                        <i>There are no SHE Files assigned to you, that have been started . </i>
                      </td>
                    </tr>
                  ) : (
                    existingSubmissions.map((sheFile, index) => (

                      <tr key={index}>

                        {/* column - SHE Pack name */}
                        <td>{index + 1}</td>

                        {/* column - Compnay Name  */}
                        <td >
                          {sheFile.company_name}
                        </td>

                        {/* column - Department name  */}
                        <td>
                          {sheFile.department_name }
                        </td>


                        {/* column - SHE Pack name */}
                        <td>{sheFile.shefile_name}</td>

                        {/* column - SHE Pack name */}
                        <td>{sheFile.submission_id || '-'}</td>

                        

                        {/* column - SHE Pack submission status */}
                        <td>{sheFile.submission_status || 'No Submissions'}</td>

                        {/* column - SHE Pack submission status */}
                        <td>{sheFile.qa_status || "-"}</td>
                        
                        {/* column - view SHE pack */}
                        <td>
                          {sheFile.submission_status === "Completed" ? (
                            // When submission status is "Completed", show disabled icon with "no entry" cursor
                            <div className="disabled-icon-container" title="Submission is already completed">
                              <FaRegFolderOpen className='view-checklist-submition-icon disabled' style={{ cursor: 'not-allowed' }} />
                            </div>
                          ) : (
                            
                            <div onClick={() => handleClickExistingSubmission(
                              sheFile.shefile_id, 
                              sheFile.shefile_name, 
                              sheFile.user_score, 
                              sheFile.shefile_score,
                              sheFile.submission_id  // Add this line
                            )}>
                              <FaRegFolderOpen className='view-checklist-submition-icon' />
                            </div>
                          )}
                        </td>

                       
                        
                      
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

      
      </div>

     

        <ToasterConsultantTemplateFill
          isOpen={showTemplateToaster}
          onClose={() => navigate('/compliance-tracker/compliance-tracker-management')}
          
          // SHE File Details
          selectedSheFileName={selectedSheFileName}
          selectedSheFileId={selectedSheFileId}
          selectedSheFileUserScore={selectedSheFileUserScore}
          onScoreUpdate={handleScoreUpdate}
          selectedSheFileScore={selectedSheFileScore}
          
          templates={templates}
          templateResponses={templateResponses}
          isLoading={isLoading}
          
          // Company and Departments
          selectedCompany={selectedCompanies[selectedSheFileId]}
          selectedCompanyName={selectedCompanyName[selectedSheFileId]}
          selectedDepartmentName={selectedDepartmentName[selectedSheFileId]}
          selectedDepartment={selectedDepartments[selectedSheFileId]}
          
          templateId={selectedTemplateId}
          templateName={selectedTemplateName}
          templateScore={selectedTemplateScore}
          templateUserPercentage={selectedTemplateUserPercentage}
          
          submissionStatus={submissionStatus}
          
          onSave={refreshAssignedSheFiles}
          onRefreshTemplates={refreshTemplates}
          
        />

        

      

      

     
     
      
        
      


    </div>
  );
};

export default ConsultantTempateFillInComponent;